const VISITOR_COOKIE_NAME = 'zawajiyyah_visitor_id';
const COOKIE_MAX_AGE_SECONDS = 60 * 24 * 60 * 60;

function getCookie(name) {
  if (typeof document === 'undefined') {
    return '';
  }

  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));

  return cookie ? decodeURIComponent(cookie.split('=').slice(1).join('=')) : '';
}

function setVisitorCookie(visitorId) {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = [
    `${VISITOR_COOKIE_NAME}=${encodeURIComponent(visitorId)}`,
    `Max-Age=${COOKIE_MAX_AGE_SECONDS}`,
    'Path=/',
    'SameSite=Lax',
    window.location.protocol === 'https:' ? 'Secure' : '',
  ].filter(Boolean).join('; ');
}

function createVisitorId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `visitor_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

function postNewVisitor(visitorId, utmSource) {
  const payload = {
    visitor_id: visitorId,
    utm_source: utmSource,
    landing_path: `${window.location.pathname}${window.location.search}`,
    referrer: document.referrer || '',
  };

  fetch('/api/statistics/new-visitor', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch((error) => {
    console.error('Failed to log new visitor:', error);
  });
}

export function trackNewVisitorFromUtm() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  const existingVisitorId = getCookie(VISITOR_COOKIE_NAME);
  if (existingVisitorId) {
    setVisitorCookie(existingVisitorId);
    return;
  }

  const visitorId = createVisitorId();
  setVisitorCookie(visitorId);

  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source');

  if (!utmSource) {
    return;
  }

  console.log('New visitor UTM source:', utmSource);
  postNewVisitor(visitorId, utmSource);
}
